/* global document */
import React, { Fragment, Component, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter as Router, Switch, Route } from 'react-router-dom'
import persistStore from './utils/redux-persist-store';
import configureStore from './store';
import { Application } from './Application';
import { UnprotectedRoutes, ProtectedRoutes, Logout } from './Authentication';
import { Login,Onboarding, Registration, PwForgotSendMail, PwForgotSetNew, Scopes, Devices, Profile, Setup, Settings, About, ChooseLanguage } from './viewcontrollers';
import SetupAuthView from './ui/views/SetupAuth/SetupAuth'
import Toaster from "./ui/components/Toaster";
// import log from 'loglevel'

import './i18n';



//@TODO use locale from settings (store)
require('moment/locale/de');

const store = configureStore({});

persistStore(store, {
  whitelist: [
    '_viewcontrollers',
    'devices',
    'authentication'
  ],
}, () => {
    window.postMessage({type: "loaded"}, "*")
});

class Loader extends Component {
  
    constructor(props) {
        super(props)

        this.state = {
            rehydrated: false
        }

        this.receiveMessage = this.receiveMessage.bind(this);
    }

   /*  handleServerError=(event)=>{
      console.error('Custom XHR Error:', event);
    } */

    
    componentDidMount() {
    

    }

    componentWillMount() {
        window.addEventListener("message", this.receiveMessage, false);
        // this.onMyLoad()
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.receiveMessage, false);
    }
    receiveMessage(evt) {
        if(evt.data.type === "loaded") {
            this.setState({
                rehydrated: true
            })
        }
    }

  




    // onMyLoad = () => {

    //   this.setState({ loading: false })
    //   let returnVal
    //   var data = { deviceid: this.props.currentDeviceId }
    //   apiClient.post('control/settings/store', data)
    //     .then(res => {
    //       if (res.status === 200) {
    //         apiClient.get(`control/settings/${this.props.currentDeviceId}`).then((res) => {
    //           returnVal = res.data.message.state.varlist
    //           // this.setState({  filters: { upTimeLimit: returnVal.id_22 }} )
    //           this.setState({ loading: false })
    //           this.setState({ deviceVarList: returnVal })
    //           this.parseVarlistToSettings()
    //           console.log(this.state.deviceVarList)
    //           console.log(this.state)
       
    //         })
    //       }
    //     })
    //     .catch((err) => {
    //       console.log("Error in Onload", err)
    //     })
    
    
    //   return returnVal
    // }

    render() {
      // this.onMyLoad()
        if(this.state.rehydrated) {
            return (<Fragment>{this.props.children}</Fragment>);
        }
        return <Fragment><div></div></Fragment>
    }
}




ReactDOM.render((
  <Provider store={store}>

    <Router>
        <Loader>
        <UnprotectedRoutes redirectTo="/">
            <Toaster/>
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path="/logout" component={Logout} />
              <Route exact path="/onboarding" component={Onboarding} />
              <Route exact path="/register" component={Registration} />
              <Route exact path="/pwdforgot" component={PwForgotSendMail} />
              <Route exact path="/pwdforgot/:token" component={PwForgotSetNew} />
             

              <ProtectedRoutes redirectTo="/login">
                <Application>
                  <Route exact path="/" component={Scopes} />
                  {/* <Route exact path="/" render={() => <Scopes onTest={this.onTest}/>} /> */}
                  <Route exact path="/devices" component={Devices} />
                  <Route exact path="/profile" component={Profile} />
                  <Route exact path="/setup" component={Setup} />
                  <Route exact path="/setupAuth" component={SetupAuthView} />
                  {/* <Route exact path="/settings" component={Settings} /> */}
                  <Route exact path="/settings" render={(routeProps) => <Settings  {...routeProps}/> }/>
                  <Route exact path="/about" component={About} />
                  {/* <Route exact path="/language" component={ChooseLanguage} /> */}
                </Application>
              </ProtectedRoutes>
            </Switch>
          </UnprotectedRoutes>
        </Loader>
    </Router>

  </Provider>
), document.getElementById('root'));



// ReactDOM.render((
//   <Provider store={store}>
//     <Router>
//             <Switch>
//               <Route exact path="/login" component={Login} />
//               <Route exact path="/logout" component={Logout} />
//               <Route exact path="/register" component={Registration} />
//               {/* <Route exact path="/pwdforgot" component={PasswordForgot} /> */}
//                 <Application>
//                   <Route exact path="/" component={Scopes} />
//                   <Route exact path="/devices" component={Devices} />
//                   <Route exact path="/profile" component={Profile} />
//                   <Route exact path="/setup" component={Setup} />
//                   <Route exact path="/settings" component={Settings} />
//                   <Route exact path="/about" component={About} />
//                 </Application>
//             </Switch>
//     </Router>
//   </Provider>
//   ), document.getElementById('root'));

// registerServiceWorker();
